import CreateClient from "./Client";

// const baseURL = process.env.REACT_APP_ADMIN_BASE_URL as string;
const AdminClient = CreateClient('ADMIN_BASE_URL');
export default AdminClient;

